import styled from 'styled-components'

export const Container = styled.div`
  padding: 20px 30px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap:20px;
`